import React, { useContext, useEffect, useState } from "react";
import Navbar from "../Navbar";
import NavbarHB from "../NavbarHB";
import Headeraccount from "../Headeraccount";
import { Button, Search, Select, Table, TextBox, ThemeProvider } from '@veneer/core';
import Footer from "../Footer";
import EncodingService from "../api/encoding/EncodingService";
import { EmailValidator } from 'commons-validator-js'
import { Modal } from "react-bootstrap";
import brand from "@veneer/hp-brand";
import { AuthContext } from "../auth/AuthContext";
import { showToast } from "../components/Toast";
import { filterSort } from "../common";
import { sortedBusinessOptions } from "../components/Sort";
import { useDownloadHandler } from "../components/DownloadHandler";
import encodingService from "../api/encoding/EncodingService";
import LoadingBar from "../components/LoadingBar";
import { AUTHENTICATED, removeLocalStorageItem } from "../utils/storage-utils";

const StyledTextBox = ({ helperText, error, children, ...props }) => {
    const containerStyle = {
        position: 'relative'
    };
    const helperTextStyle = {
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        paddingTop: '12px ',
        marginTop: '12px',
        fontSize: '14px',
        backgroundColor: '#ffffff',
        border: 'none',
        borderRadius: '4px',
        color: '#000000',
        lineHeight: '1.5',
        display: helperText ? 'flex' : 'none',
        alignItems: 'center',
        gap: '5px',
        zIndex: 10
    };
    const RedCircleIcon = () => (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            style={{ minWidth: '18px' }}
        >
            <circle
                cx="12"
                cy="12"
                r="10.5"
                fill="#CC2C00"
                stroke="#CC2C00"
                strokeWidth="1"
            />
            <line
                x1="6"
                y1="12"
                x2="18"
                y2="12"
                stroke="white"
                strokeWidth="1.4"
                strokeLinecap="round"
            />
        </svg>
    );
    return (
        <div style={containerStyle}>
            <TextBox {...props} helperText="" style={{
                ...props.style,
                border: helperText ? '1px solid #CC2C00' : props.style?.border,
            }} />
            <div style={helperTextStyle}>
                {helperText && (
                    <>
                        <RedCircleIcon />
                        <span>{helperText}</span>
                    </>
                )}
            </div>
        </div>
    );
};


export const lookup = {
    "Select Business": [
        { value: 'Select role', label: 'Select role' }
    ],
    "HP": [
        { value: 'Supplies Business Owner', label: 'Supplies Business Owner' }
    ],
    "SPTS": [
        { value: 'SPTS Viewer', label: 'SPTS Viewer' },
        { value: 'SPTS Sales Rep', label: 'SPTS Sales Rep' },
        { value: 'SPTS Pricing Admin', label: 'SPTS Pricing Admin' },
        { value: 'SPTS Administrator', label: 'SPTS Administrator' }
    ],
    "Renew": [
        { value: 'Operator', label: 'Operator' },
        { value: 'Supervisor', label: 'Supervisor' },
        { value: 'Administrator', label: 'Administrator' }
    ]
}


const Administratoraccount = (props) => {

    const debug = false
    const fullName = '';
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('');
    const [business, setBusiness] = useState('');
    const [tableData, setTableData] = useState([]);
    const [businessOption, setBusinessOption] = useState([]);
    const [addUserResult, setAddUserResult] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [businessError, setBusinessError] = useState(false);
    const [roleError, setRoleError] = useState(false);
    const [addUserResultColor, setAddUserResultColor] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenError, setIsOpenError] = useState(false);
    const [idToDelete, setIdToDelete] = useState(-1);
    const [idToEdit, setIdToEdit] = useState(-1); // Add this new state
    const [errDesOnDelete, setErrDesOnDelete] = useState('');
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [roleEditValue, setRoleEditValue] = useState('');
    const [businessEditValue, setBusinessEditValue] = useState('');
    const [editUserRec, setEditUserRec] = useState({});
    const [saveDisable, setSaveDisable] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [userToBeDeleted, setUserToBeDeleted] = useState({});
    const [loading, setLoading] = useState(false);
    const [userEmailErrorMessage, setUserEmailErrorMessage] = useState('');
    const [userBusinessErrorMessage, setUserBusinessErrorMessage] = useState('');
    const [userRoleErrorMessage, setUserRoleErrorMessage] = useState('');
    const [emailFilterValue, setEmailFilterValue] = useState('')
    const [businessFilterValue, setBusinessFilterValue] = useState('')
    const [roleFilterValue, setRoleFilterValue] = useState([])
    const [roleId, setRoleId] = useState(null)
    const [rolesByBusinessId, setRolesByBusinessId] = useState([])
    const [orderType, setOrderType] = useState('ascending');
    const [orderBy, setOrderBy] = useState("email")
    const [activityLoading, setActivityLoading] = useState(false);

    const { uiAccess } = useContext(AuthContext);

    const downloadActivityHandler = useDownloadHandler(encodingService.downloadActivity, setActivityLoading);

    const getAllUsers = () => {
        setLoading(true)
        EncodingService.getAllUser().then((res) => {
            let dbTableData = [];
            res?.data?.forEach((item) => {
                let roleStatus;
                if (item.role === "Administrator") {
                    roleStatus = "Full access for the user's business";
                } else if (item.role === "Operator") {
                    roleStatus = "Access to the download page and encoding API for the user's business";
                } else if (item.role === "Supervisor") {
                    roleStatus = "Access to the download page, encoding API, and monthly summary for the user's business";
                } else if (item.role === "SPTS Viewer") {
                    roleStatus = "View only access to Reman account information";
                } else if (item.role === "SPTS Sales Rep") {
                    roleStatus = "Access Adds/changes Remans accounts, updates supply cap, and makes adjustments. Cannot change price";
                } else if (item.role === "SPTS Pricing Admin") {
                    roleStatus = "Can enable supplies and update price per Reman account";
                } else if (item.role === "SPTS Administrator") {
                    roleStatus = "Manages Reman accounts, users, target supplies, and SW Catalog";
                } else if (item.role === "Supplies Business Owner") {
                    roleStatus = "Owns product catalog. Able to configure SKUs.";
                } else {
                    roleStatus = "NA";
                }
                let obj = {
                    email: item.email,
                    name: item.fullName,
                    businessId: item.businessName,
                    roles: item.role,
                    edit: <Button disabled={item['currentUser']} id={"" + item.id} small={true} onClick={() => edit(item, roleStatus)} appearance="secondary">Edit</Button>,
                    delete: <Button disabled={!item['canDelete']} id={"delete" + item.id} small={true} onClick={() => deleteAccount(item.id, item.email)} appearance="secondary">Delete</Button>,
                    selectedOption: 'None',
                    counter: "delete" + item.id,
                    id: item.id,
                    status: roleStatus
                }
                dbTableData.push(obj)
            });
            setTableData(dbTableData)
            setLoading(false)
        }).catch(() => {
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href = "/supplyencodingsvc/?state=Error";
        });
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const handlePageSizeChange = (event, option) => {
        setPageSize(option.value)
    };

    const validateEmail = (email) => {

        const validator = new EmailValidator()
        return validator.isValid(email)

    }

    const saveAdminAccount = () => {
        let index = tableData.length;
        let name = fullName
        let status = ''
        let returnValue = true;

        setAddUserResult('')
        setAddUserResultColor('')

        if (email === '') {
            setEmailError(true)
            setUserEmailErrorMessage('Enter email address')
            setAddUserResultColor(brand.color.red)
            returnValue = false;
        }
        else if (!validateEmail(email)) {
            setEmailError(true)
            setUserEmailErrorMessage('Enter valid email address')
            setAddUserResultColor(brand.color.red)
            returnValue = false;
        }
        else {
            setEmailError(false)
            setUserEmailErrorMessage('')
            setAddUserResultColor('')
        }

        if (business === '' || business === 'Select Business') {
            setBusinessError(true)
            setUserBusinessErrorMessage('Select business')
            setAddUserResultColor(brand.color.red)
            returnValue = false;
        }
        else {
            setBusinessError(false)
            setUserBusinessErrorMessage('')
            setAddUserResultColor('')
        }
        if (role === '' || role === 'Select role') {
            setRoleError(true)
            setUserRoleErrorMessage('Select role')
            setAddUserResultColor(brand.color.red)
            returnValue = false;
        } else {
            setRoleError(false)
            setUserRoleErrorMessage('')
            setAddUserResultColor('')
        }

        if (role === "Administrator" || role === "SPS") {
            status = "Full access for the user's business"
        }
        if (role === "Viewer") {
            status = "Can edit accounts and cap/pricing"
        }
        if (role === "Sales Rep") {
            status = "Can view accounts and cap/pricing"
        }

        tableData.forEach((item) => {
            if (item.email === email) {
                setAddUserResult("Error : Email Exists!")
                setAddUserResultColor(brand.color.red)
                returnValue = false;
            }
        });
        if (!returnValue) return returnValue;
        if (returnValue) {
            setAddUserResult("")
            setUserBusinessErrorMessage('')
            setUserRoleErrorMessage('')
            setAddUserResultColor('')

            let user = {
                email: email,
                business_name: business,
                roles: role,
                status: status,
                roleId: roleId
            }

            EncodingService.addNewUser(user).then(res => {
                console.log(res.data)
                // Only add to table on success
                let tableAccount = tableData;
                let roleStatus;
                if (role === "Administrator") {
                    roleStatus = "Full access for the user's business";
                } else if (role === "Operator") {
                    roleStatus = "Access to the download page and encoding API for the user's business";
                } else if (role === "Supervisor") {
                    roleStatus = "Access to the download page, encoding API, and monthly summary for the user's business";
                } else if (role === "Viewer") {
                    roleStatus = "View only access to Reman account information";
                } else if (role === "Sales Rep") {
                    roleStatus = "Access Adds/changes Remans accounts, updates supply cap, and makes adjustments. Cannot change price";
                } else if (role === "Pricing Admin") {
                    roleStatus = "Can enable supplies per business and update price";
                } else if (role === "SPS Administrator") {
                    roleStatus = "Manages Reman accounts, users, target supplies, and SW Catalog";
                } else if (role === "Supplies Business Owner") {
                    roleStatus = "Owns product catalog. Able to configure SKUs";
                } else {
                    roleStatus = "NA";
                }
                let row = {
                    name: name,
                    email: email,
                    businessId: business,
                    roles: role,
                    edit: <Button id={res.data.id} small={true} disabled={res.data.currentUser} onClick={() => edit(res.data, roleStatus)} appearance="secondary" > Edit</Button>,
                    delete: <Button id={"delete" + res.data.id} small={true} disabled={!res.data.canDelete} onClick={() => deleteAccount(res.data.id, email)} appearance="secondary" > Delete</Button>,
                    selectedOption: 'None',
                    counter: "delete" + index,
                    status: roleStatus,
                    id: res.data.id
                };

                tableAccount.push(row);

                props.history.push('/sps-admin');
                setTableData(tableAccount)
                showToast("User added successfully.", 'success')
                setAddUserResult('')
                setEmail('')
                setBusiness('Select Business')
                setRole('Select role')
                pageSize === tableData.length - 1 && setPageSize(tableData.length)
                setAddUserResultColor('#024ad8')
            }, (error) => {
                setAddUserResult("Error : " + error.response.data.message)
                setAddUserResultColor(brand.color.red)
            });
        }

    }

    const deleteUser = () => {

        setBtnLoading(true);

        // Validate ID
        const numericId = Number(idToDelete);

        if (!idToDelete || numericId <= 0 || isNaN(numericId)) {
            setIsOpenError(true);
            setIdToDelete(-1);
            setErrDesOnDelete(`Invalid user ID: ${idToDelete}. Cannot delete user.`);
            setBtnLoading(false);
            return;
        }

        if (numericId === 1) {
            setIsOpenError(true);
            setIdToDelete(-1);
            setErrDesOnDelete('Cannot delete admin user');
            setBtnLoading(false);
            return;
        }


        EncodingService.deleteUser(numericId).then(() => {
            showToast("User Deleted Successfully.", 'success');

            // Filter out the deleted user
            let newList = tableData.filter(item => item.id !== numericId);

            setIdToDelete(-1);
            setTableData(newList);
            setIsOpen(false);
            setBtnLoading(false);

            // Fix pagination calculation
            let page_data = newList.slice((currentPage - 1) * pageSize,
                (currentPage - 1) * pageSize + pageSize);

            if (page_data.length === 0 && currentPage > 1) {
                setCurrentPage(currentPage - 1);
            }
        }, (error) => {
            setIsOpenError(true);
            setIdToDelete(-1);
            setErrDesOnDelete(error.response?.data?.message || 'Delete failed');
            setIsOpen(false);
            setBtnLoading(false);
        });
    }
    const deleteAccount = (id, email) => {
        setUserToBeDeleted(email)
        setIsOpen(true)
        setIdToDelete(id)
    }

    const edit = (item, roleStatus) => {
        const id = Number(item.id);
        setIsEditOpen(true)
        setIdToEdit(id)
        setEditUserRec({ ...item, status: roleStatus })
        setBusinessEditValue(item?.businessName)
        getRolesByBusinessId(item?.businessId)
        setRoleEditValue(item?.role)
    }

    const handleEditBusinessChange = (e) => {
        setBusinessEditValue(e.value)
        getRolesByBusinessId(e.id)
        setRoleEditValue('')
        setSaveDisable(true)
    }
    const setRoleModal = (e) => {
        setRoleEditValue(e.value)
        setSaveDisable(false)
        if (roleEditValue === 'Select role') {
            setSaveDisable(true)
        }
        else {
            setSaveDisable(false)
        }
    }


    const editUser = () => {
        const user = {
            email: editUserRec.email,
            id: idToEdit,
            business_name: businessEditValue,
            roles: roleEditValue,
            status: editUserRec.status
        }
        if ((businessEditValue === 'SPTS' || businessEditValue === 'HP') && editUserRec.email.split('@')[1] !== 'hp.com') {
            setIsEditOpen(false)
            showToast(<p>Error: Unable to add a non-HP user to <b>{businessEditValue}</b> business.</p>, 'error')
        } else {
            EncodingService.updateUser(user).then(() => {
                setIsEditOpen(false)
                showToast("User Role Updated Successfully.", 'success')
                getAllUsers();

            }, (error) => {
                setIsEditOpen(false)
                showToast(<p>Error editing user. Please try again later.<br /><b>{error.response.data.message}</b></p>, 'error')
            }
            );
        }
    }

    const hideEditModal = () => {
        setIsEditOpen(false)
        setIdToEdit(-1)
    }

    const onChangeBusiness = (e) => {
        setBusiness(e.value)
        setRole('')
        setUserBusinessErrorMessage('')
        setBusinessError(false)
        getRolesByBusinessId(e.id)
    }

    const getRolesByBusinessId = (businessId) => {
        EncodingService.getRolesByBusiness(businessId).then(res => {
            const roles = res.data;
            setRolesByBusinessId(roles)
        }, (error) => {
            console.log(error)
        });
    }

    const hideModal = () => {
        setIsOpen(false)
    };
    const hideModalError = () => {
        setIsOpenError(false)
    };
    const handleChangeRole = (e) => {
        setRoleId(e.roleId)
        setRole(e.value)
        setUserRoleErrorMessage('')
        setRoleError(false)
    }

    const handleSort = (event, sortBy) => {
        setOrderBy(sortBy.id)
        setOrderType(sortBy.type);
    }

    const emailOnChange = (email) => {
        setEmail(email)
        setUserEmailErrorMessage('')
        setEmailError(false)
    }

    const handleEmailFilter = (value) => {
        setEmailFilterValue(value);
        setCurrentPage(1); // Reset to the first page
    };

    const handleBusinessFilter = (value) => {
        setBusinessFilterValue(value);
        setCurrentPage(1); // Reset to the first page
    };

    const handleRoleFilter = (e) => {
        setRoleFilterValue([e.value]);
        setCurrentPage(1); // Reset to the first page
    };
    const rolesForFilter = lookup.SPTS.concat(lookup.HP, lookup.Renew)
    const columns = [
        {
            id: "email",
            label: "EMAIL",
            filter: (
                <Search
                    label="Search"
                    placeholder="Placeholder"
                    id="table-filter-Name"
                    value={emailFilterValue}
                    onClear={() => setEmailFilterValue('')}
                    onChange={handleEmailFilter}
                />
            )
        },
        {
            id: "name",
            label: "NAME",
        },
        {
            id: "businessId",
            label: "BUSINESS",
            filter: (
                <Search
                    label="Search"
                    placeholder="Placeholder"
                    id="table-filter-business"
                    value={businessFilterValue}
                    onClear={() => setBusinessFilterValue('')}
                    onChange={handleBusinessFilter}
                />
            )
        },
        {
            id: "roles",
            label: "ROLE",
            filter: (
                <Select
                    label="Select Role"
                    id="table-filter-gender"
                    options={rolesForFilter}
                    onClear={() => setRoleFilterValue([])}
                    onChange={handleRoleFilter}
                    value={roleFilterValue}
                />
            ),
        },
        {
            id: "edit",
            label: ""
        },
        {
            id: "delete",
            label: "",
        },
        {
            id: "status",
            label: "",
        },
    ]

    const filteredData = filterSort(
        tableData,
        {
            email: emailFilterValue,
            roles: roleFilterValue,
            businessId: businessFilterValue
        },
        orderBy,
        orderType
    );

    const handleOnClearAllFilters = () => {
        setEmailFilterValue('')
    }

    useEffect(() => {
        EncodingService.getAllAccount().then((res) => {
            let arr = []

            res?.data?.forEach(element => {
                let data = {
                    businessName: element.businessName,
                    businessId: element.id
                }
                arr.push(data);
            }
            );
            setBusinessOption(arr);

        }).catch(() => {
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href = "/supplyencodingsvc/?state=Error";
        });
        getAllUsers();
    }, [])

    return (
        <div>
            <Headeraccount />
            {uiAccess?.navbarSPS && <Navbar role={props.role} />}
            {uiAccess?.navbarHB && <NavbarHB role={props.role} />}
            <div className="tableWrapper">
                <div className="row justify-content-start" id="admin">
                    <div className="col-md">
                        <div id="add-user" className="add-email-user">
                            <div className="h4-label">
                                <label className="subtitle-large">
                                    Add users:
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-md-6 col-lg-6 col-xs-8 col-sm-12 m-b-25">
                                    <div className="details">EMAIL</div>
                                    <ThemeProvider
                                        mode="light"
                                        shape="round"
                                        density="high"
                                        id="emailadmin"
                                    >
                                        <StyledTextBox
                                            density="high"
                                            id="email"
                                            className="text-l input-text email-address"
                                            name="email"
                                            required
                                            value={email}
                                            onChange={(email) => emailOnChange(email)}
                                            placeholder=""
                                            maxLength={256}
                                            error={emailError}
                                            helperText={userEmailErrorMessage}
                                            style={{ height: '2rem' }}
                                        />
                                    </ThemeProvider>
                                </div>
                            </div><br />
                            <div className="col-md-2">
                                <span id="reqTxtName" className="reqError req-error"></span>
                            </div>
                            <div className="row align-items-start"> 
                                <div className="col-md-3 col-lg-2"> 
                                    <div className="details m-t-30">BUSINESS</div>
                                    <div style={{ position: 'relative', marginBottom: '50px' }}>
                                        <ThemeProvider mode="light" shape="round" density="high">
                                            <Select
                                                id={"business"}
                                                name="business"
                                                clearIcon={false}
                                                value={[business]}
                                                placeholder={'Select Business'}
                                                onChange={(e) => onChangeBusiness(e)}
                                                options={sortedBusinessOptions(businessOption, 'sortAdministration')}
                                                error={businessError}
                                                helperText=""
                                                style={{
                                                    border: userBusinessErrorMessage ? '1px solid #CC2C00' : undefined
                                                }}
                                            />
                                        </ThemeProvider>
                                        {userBusinessErrorMessage && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: '0',
                                                padding: '12px 16px',
                                                marginTop: '8px',
                                                fontSize: '14px',
                                                backgroundColor: '#ffffff',
                                                color: '#000000',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                zIndex: 10,
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <svg width="18" height="18" viewBox="0 0 24 24" style={{ minWidth: '18px' }}>
                                                    <circle cx="12" cy="12" r="10.5" fill="#CC2C00" stroke="#CC2C00" strokeWidth="1" />
                                                    <line x1="6" y1="12" x2="18" y2="12" stroke="white" strokeWidth="1.4" strokeLinecap="round" />
                                                </svg>
                                                <span>{userBusinessErrorMessage}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="col-md-3 col-lg-2"> 
                                    <div className="details m-t-30">ROLE</div>
                                    <div style={{ position: 'relative', marginBottom: '50px' }}>
                                        <ThemeProvider mode="light" shape="round" density="high">
                                            <Select
                                                id={"role"}
                                                name="role"
                                                clearIcon={false}
                                                value={[role]}
                                                placeholder={'Select role'}
                                                onChange={(e) => handleChangeRole(e)}
                                                options={rolesByBusinessId ? rolesByBusinessId.map(e => {
                                                    return { value: e.roleName, label: e.roleName, roleId: e.id }
                                                }) : []}
                                                error={roleError}
                                                helperText=""
                                                style={{
                                                    border: userRoleErrorMessage ? '1px solid #CC2C00' : undefined
                                                }}
                                            />
                                        </ThemeProvider>
                                        {userRoleErrorMessage && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: '0',
                                                padding: '12px 16px',
                                                marginTop: '8px',
                                                fontSize: '14px',
                                                backgroundColor: '#ffffff',
                                                color: '#000000',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                zIndex: 10,
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <svg width="18" height="18" viewBox="0 0 24 24" style={{ minWidth: '18px' }}>
                                                    <circle cx="12" cy="12" r="10.5" fill="#CC2C00" stroke="#CC2C00" strokeWidth="1" />
                                                    <line x1="6" y1="12" x2="18" y2="12" stroke="white" strokeWidth="1.4" strokeLinecap="round" />
                                                </svg>
                                                <span>{userRoleErrorMessage}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="col-md-3 col-lg-3"> 
                                    <div style={{
                                        marginTop: '23px', 
                                        height: '40px',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <Button
                                            id={"addBtn"}
                                            small={true}
                                            onClick={saveAdminAccount}
                                            appearance="secondary"
                                            className="button-p"
                                        >
                                            Add
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-xs-12 col-sm-12">
                                    <br></br>

                                    <span
                                        style={{ color: addUserResultColor }}
                                        className="useradded"
                                    >
                                        {addUserResult}
                                    </span>

                                </div>
                            </div>
                        </div>

                        <h5 className="subtitle-large p-60">Who has access:</h5>
                        <Table
                            showFilters
                            columnResize={true}
                            loading={loading}
                            onClearAllFilters={handleOnClearAllFilters}
                            id="admin_account_table"
                            columns={columns}
                            data={
                                // Apply filtering first, then slice for pagination
                                filterSort(
                                    tableData,
                                    {
                                        email: emailFilterValue,
                                        roles: roleFilterValue,
                                        businessId: businessFilterValue,
                                    },
                                    orderBy,
                                    orderType
                                ).slice(
                                    (currentPage - 1) * pageSize,
                                    (currentPage - 1) * pageSize + pageSize
                                )
                            }
                            pagination={{
                                currentPage: currentPage,
                                pageSizeOptions:
                                    filteredData.length <= 2
                                        ? [{ value: filteredData.length }]
                                        : filteredData.length < 5
                                            ? [{ value: 2 }, { value: filteredData.length }]
                                            : filteredData.length <= 8
                                                ? [{ value: 2 }, { value: 4 }, { value: filteredData.length }]
                                                : filteredData.length <= 9
                                                    ? [{ value: 2 }, { value: 4 }, { value: 8 }, { value: filteredData.length }]
                                                    : filteredData.length <= 10
                                                        ? [{ value: 2 }, { value: 4 }, { value: 8 }, { value: filteredData.length }]
                                                        : [{ value: 2 }, { value: 4 }, { value: 8 }, { value: 10 }, { value: filteredData.length }],
                                onPageChange: handlePageChange,
                                onPageSizeChange: handlePageSizeChange,
                                totalItems: filterSort(
                                    tableData,
                                    {
                                        email: emailFilterValue,
                                        roles: roleFilterValue,
                                        businessId: businessFilterValue,
                                    },
                                    orderBy,
                                    orderType
                                ).length, // Ensure pagination reflects filtered data
                                pageSize: pageSize,
                            }}
                            onSort={handleSort}
                            preferences={{
                                sortBy: {
                                    id: orderBy,
                                    type: orderType,
                                },
                            }}
                        />
                        <div className="row justify-content-start p-l-10 p-80">
                            <p className="f-w">
                                {activityLoading ? (
                                    <>
                                        <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px', color: '#024ad8' }}></i>
                                        <span style={{ color: '#024ad8' }}>Downloading...</span>
                                        <LoadingBar />
                                    </>
                                ) : (
                                    <>
                                        Download{" "}
                                        <span className="activitylog c-p">
                                            <a
                                                className={`a-link`}
                                                style={{ color: '#024ad8' }}
                                                onClick={(e) => downloadActivityHandler(e, [])}
                                                href={"#"}
                                            >
                                                Activity Log
                                            </a>
                                        </span>{" "}
                                        to see detailed history of account activity
                                    </>
                                )}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            <Modal show={isOpen} onHide={hideModal}>
                <Modal.Body>
                    <div id="admin-delete" className="modal-body">
                        <p className="f-14">
                            Are you sure you want to delete {userToBeDeleted}?
                        </p>
                    </div>
                </Modal.Body>

                <div className="modal-footer justify-content-md-center b-t-0">
                    <ThemeProvider mode="light" shape="round" density="high">
                        <Button
                            id="reportErrorCloseBtn"
                            small={true}
                            data-dismiss="modal"
                            appearance="secondary"
                            className="spsaccount m-r-21"
                            onClick={hideModal}
                        >
                            Cancel
                        </Button>
                    </ThemeProvider>
                    <br />

                    <ThemeProvider mode="light" shape="round" density="high">
                        <Button
                            loading={btnLoading}
                            id="reportErrorCloseBtnDel"
                            small={true}
                            className="button-p"
                            data-dismiss="modal"
                            onClick={deleteUser}
                        >
                            OK
                        </Button>
                    </ThemeProvider>
                </div>
            </Modal>

            <Modal show={isOpenError} onHide={hideModalError}>
                <Modal.Body>
                    <div className="modal-body justify-content-md-center">
                        <p className="f-14">
                            {" "}
                            Error deleting user. Please try again later.
                        </p>
                        <p className="f-14">{errDesOnDelete}</p>
                    </div>
                </Modal.Body>
                <div className="modal-footer justify-content-md-center b-t-0">
                    <ThemeProvider mode="light" shape="round" density="high">
                        <Button
                            id="modalCloseBtn"
                            small={true}
                            data-dismiss="modal"
                            appearance="secondary"
                            className="spsaccount m-r-21"
                            onClick={hideModalError}
                        >
                            OK
                        </Button>
                    </ThemeProvider>
                </div>
            </Modal>
            <Modal show={isEditOpen} onHide={hideEditModal}>
                <Modal.Body>
                    <div>Select business and role for {editUserRec?.email} </div>
                    <br></br>
                    <div className="modal-edit">
                        <div className="details m-t-30 modal-edit-col">BUSINESS</div>
                        <div style={{ width: 20 + 'rem' }}>
                            <ThemeProvider mode="light" shape="round" density="high" id="emailadmin">
                                <Select
                                    id={"editBusiness"}
                                    name="editBusiness"
                                    clearIcon={false}
                                    value={[businessEditValue]}
                                    placeholder={'Select Business'}
                                    onChange={handleEditBusinessChange}
                                    options={businessOption.map(e => {
                                        return { value: e.businessName, id: e.businessId }
                                    })} />
                            </ThemeProvider>
                        </div>
                    </div>
                    <br />
                    <div className="modal-edit">
                        <div className="details m-t-30 modal-edit-col">ROLE</div>
                        <div style={{ width: 20 + 'rem' }}>
                            <ThemeProvider mode="light" shape="round" density="high" id="emailadmin">
                                <Select
                                    id={"editRole"}
                                    name="editRole"
                                    clearIcon={false}
                                    value={[roleEditValue]}
                                    placeholder={'Select Role'}
                                    onChange={setRoleModal}
                                    options={rolesByBusinessId ? rolesByBusinessId?.map((e) => {
                                        return { value: e.roleName, label: e.roleName, roleId: e.id }
                                    }) : []} />
                            </ThemeProvider>
                        </div>
                    </div>
                </Modal.Body>
                <div className="modal-footer justify-content-md-center b-t-0">
                    <ThemeProvider mode="light" shape="round" density="high">
                        <Button
                            id="reportErrorCloseBtn"
                            small={true}
                            data-dismiss="modal"
                            appearance="secondary"
                            className="spsaccount m-r-21"
                            onClick={hideEditModal}
                        >
                            Cancel
                        </Button>
                    </ThemeProvider>
                    <br />

                    <ThemeProvider mode="light" shape="round" density="high">
                        <Button
                            id="reportErrorCloseBtnSave"
                            small={true}
                            className="button-p"
                            data-dismiss="modal"
                            disabled={saveDisable}
                            onClick={editUser}
                        >
                            Save
                        </Button>
                    </ThemeProvider>
                </div>
            </Modal>
            <div
                className="modal fade"
                id="staticBackdrop"
                data-backdrop="static"
                data-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content p-20">
                        <div className="modal-body b-b">
                            <h4 className="h4-header t-c"> Delete</h4>
                            <p className="f-14">
                                Are you sure you want to delete this item
                            </p>
                            <br />
                            <br />
                        </div>
                        <div className="modal-footer justify-content-md-center">
                            <ThemeProvider mode="light" shape="round" density="high">
                                <Button
                                    disabled={debug}
                                    id="reportErrorCloseBtn"
                                    small={true}
                                    className="button-p m-r-20"
                                    data-dismiss="modal"
                                >
                                    Delete
                                </Button>
                            </ThemeProvider>
                            <br />

                            <ThemeProvider mode="light" shape="round" density="high">
                                <Button
                                    id="reportErrorCloseBtn"
                                    small={true}
                                    data-dismiss="modal"
                                    appearance="secondary"
                                    className="spsaccount"
                                >
                                    Cancel
                                </Button>
                            </ThemeProvider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Administratoraccount;